import { useState, FormEvent, useContext } from 'react'
import { cadastrarUsuario, atualizarUsuario } from '../../services/usuarios'
import { telefoneMascara } from '../../helpers'
import { ModalUsuarioDados } from '../../interfaces/usuarios'
import { Button, Loader } from '../Styles'
import '../../styles/modal.css'
import { ModalEstadoContext } from '../../contexts/ModalEstado'
import { toast } from 'react-toastify'
import { useLocation } from 'react-router-dom'

function ModalUsuario({ usuario }: ModalUsuarioDados) {

    const { search } = useLocation()
    const { atualizarDados, modalExibir } = useContext(ModalEstadoContext)

    const [nome, setNome] = useState(usuario?.usuario.nome || '')
    const [email, setEmail] = useState(usuario?.usuario.email || '')
    const [telefone, setTelefone] = useState(usuario?.usuario.telefone || "")
    const [situacao, setSituacao] = useState(usuario?.usuario.situacao || "")
    const [senha, setSenha] = useState('')
    const [confirmarSenha, setConfirmarSenha] = useState('')

    const paramsUrl = new URLSearchParams(search)
    const idProjeto = paramsUrl.get("idProjeto")

    const [processando, setProcessando] = useState(false)

    const ocultarModal = () => {
        return modalExibir("")
    }

    function conferirSenha() {

        if (senha !== confirmarSenha) {
            setSenha('')
            setConfirmarSenha('')
            toast.warn("As senhas não conferem. Digite novamente!")
        }
    }

    const changeTelefone = (e: any) => {
        return setTelefone(telefoneMascara(e))
    }

    const novoUsuario = async (e: FormEvent) => {
        e.preventDefault()
        setProcessando(true)
        if (!idProjeto) return toast.error("Projeto não encontrado.")
        try {

            const payload = {
                idProjeto,
                nome,
                email,
                senha,
                telefone
            }

            const resposta = await cadastrarUsuario(payload)

            if (resposta.status === 201) {
                atualizarDados()
                modalExibir("")
                setProcessando(false)
                return toast.success("Usuário Cadastrado com Sucesso.")
            }

        } catch (error: any) {
            setProcessando(false)
            if (error.response.status === 405) return toast.warn("Já Existe um Usuário com esse E-mail!")

            if (error.response.status === 408) return toast.warn("Limite de Usuários Ativos do Plano Atingido.")

            if (error.response.status === 400) return toast.error("Ocorreu um erro ao tentar salvar os dados!")
        }
    }

    const atualizarDadosUsuario = async (e: FormEvent) => {
        if (!usuario) return toast.error("Usuario não encontrado.")
        e.preventDefault()
        setProcessando(true)

        const idUsuario = usuario.usuario.id

        const payload = {
            nome,
            telefone,
            situacao
        }

        try {

            const resposta = await atualizarUsuario(idUsuario, payload)

            if (resposta.status === 200) {
                setProcessando(false)
                toast.success("Dados Atualizados com Sucesso.")
                atualizarDados()
                modalExibir("")
            }

        } catch (error: any) {
            setProcessando(false)
            if (error.response.status === 408) return toast.warn("Limite de Usuários Ativos do Plano Atingido.")
            return toast.error("Ocorreu um erro ao tentar salvar os dados!")
        }
    }

    return (
        <div id='fundoModal'>
            <section id='containerModalNovo'>
                <span id='novoContainerTitulo'>
                    <p>{!usuario ? 'Novo Usuário' : 'Atualizar Dados'}</p>
                </span>
                <form id='formModalNovo' onSubmit={!usuario ? novoUsuario : atualizarDadosUsuario}>
                    <section>
                        <span>
                            <label htmlFor="nomeUsario">Nome</label>
                            <input
                                id='nomeUsario'
                                type="text"
                                value={nome}
                                placeholder='Digite o nome e sobre nome do usuário'
                                onChange={(e) => setNome(e.target.value)}
                                required />
                        </span>
                    </section>

                    <section>
                        {!usuario && <span>
                            <label htmlFor="emailUsario">E-mail</label>
                            <input
                                id='emailUsario'
                                type="email"
                                value={email}
                                placeholder='Digite o e-mail de acesso ao sistema'
                                onChange={(e) => setEmail(e.target.value)}
                                required
                            />
                        </span>}
                        <span>
                            <label htmlFor="telefoneUsario">Telefone</label>
                            <input
                                id="telefoneUsuario"
                                type="text"
                                value={telefone === null ? '' : telefone}
                                placeholder="(00) 0.0000 - 0000"
                                minLength={18}
                                maxLength={18}
                                onChange={(e) => changeTelefone(e.target.value)}
                                required />
                        </span>
                    </section>

                    <section>
                        {usuario && <span>
                            <label htmlFor="situacaoUsario">Situação</label>
                            <select id="situacaoUsario" value={situacao} onChange={(e) => setSituacao(e.target.value)} required>
                                <option value="ativo">Ativo</option>
                                <option value="inativo">Inativo</option>
                            </select>
                        </span>}
                    </section>

                    {!usuario && <section>
                        <span>
                            <label htmlFor="senhaUsuario">Senha</label>
                            <input
                                type="password"
                                id="senhaUsuario"
                                value={senha}
                                placeholder='Digite uma senha com 08 dígitos'
                                minLength={8}
                                maxLength={8}
                                required
                                onChange={(e) => setSenha(e.target.value)} />
                        </span>
                        <span>
                            <label htmlFor="confirmarSenhaUsuario">ConFirmar Senha</label>
                            <input
                                type="password"
                                id="confirmarSenhaUsuario"
                                value={confirmarSenha}
                                placeholder='Digite uma senha novamente'
                                minLength={8}
                                maxLength={8}
                                required
                                onChange={(e) => setConfirmarSenha(e.target.value)}
                                onBlur={conferirSenha} />
                        </span>
                    </section>}
                    <span id="botoesContainer">
                        <Button type='button' cor='cancelar' isLoading={processando} onClick={ocultarModal}>Cancelar</Button>
                        <Button type='submit' cor='salvar' isLoading={processando}>
                            {!processando && 'Salvar Dados'}
                            {processando && <Loader isLoading={processando} />}
                        </Button>
                    </span>
                </form>
            </section>
        </div>
    )
}

export default ModalUsuario
